var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 6.512a8.641 8.641 0 01-2.474.676 4.308 4.308 0 001.894-2.374 8.649 8.649 0 01-2.736 1.041A4.31 4.31 0 0016.039 4.5c-2.38 0-4.308 1.922-4.308 4.292 0 .336.038.664.111.978a12.247 12.247 0 01-8.88-4.484 4.285 4.285 0 001.333 5.73 4.304 4.304 0 01-1.951-.537v.054A4.298 4.298 0 005.8 14.74a4.33 4.33 0 01-1.946.073 4.31 4.31 0 004.024 2.98 8.666 8.666 0 01-5.35 1.838c-.348 0-.69-.02-1.028-.06A12.23 12.23 0 008.104 21.5c7.925 0 12.259-6.54 12.259-12.21 0-.187-.005-.372-.013-.556a8.736 8.736 0 002.15-2.222z",
    fill: "currentColor"
  })));
}
export default SvgLogoTwitter;